module.exports = __webpack_public_path__ + "img/mybk.128b9b3b.jpg";